import KoobSidebarLink from './KoobSidebarLink';

export default function KoobSidebarSection({
  title,
  links = [] as any[],
  collapsed = false,
}) {
  return (
    <div className="px-3">
      {title && !collapsed && (
        <div className="px-3 pt-4 pb-1 text-xs font-semibold uppercase text-muted-foreground tracking-wider">
          {title}
        </div>
      )}
      {title && collapsed && (
        <div className="my-2 mx-auto w-6 border-t border-border" />
      )}
      <div className="space-y-1">
        {links.map((link, index) => (
          <KoobSidebarLink key={index} link={link} collapsed={collapsed} />
        ))}
      </div>
    </div>
  );
}
